import { Icon } from '@iconify/react';
import React, { useRef, useState } from 'react';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';

// material
import { Menu, MenuItem, IconButton, ListItemText, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useAuth } from '../../customContextProviders/AuthContext';
import useFeatures from '../../customContextProviders/FeatureContext';

// ----------------------------------------------------------------------
const useStyles = makeStyles((theme) => ({
  menuItem: {
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    },
    minHeight: '20px',
    borderRadius: '8px',
    marginInline: theme.spacing(1)
  }
}));
export default function DeviceMoreMenu({ handleUser, handleClicks }) {
  const classes = useStyles();
  const { sessionUserData } = useAuth();
  const feature = useFeatures();
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  const userRole = sessionUserData?.user?.userRole?.roleName;

  return (
    <Box>
      <IconButton data-testid="more-menu-icon" ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' }
        }}
        sx={{
          '& .MuiListItemText-root > .MuiTypography-root': {
            color: '#000',
            fontWeight: 600,
            fontStyle: 'normal'
          }
        }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {handleUser?.tripData && (
          <MenuItem
            onClick={() => {
              setIsOpen(false);
              handleClicks('view_trips');
            }}
            sx={{ color: 'text.secondary', gap: 2 }}
            className={classes.menuItem}
          >
            <ListItemText primary="View Live Trip" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}

        <MenuItem
          onClick={() => {
            setIsOpen(false);
            handleClicks('device_report');
          }}
          sx={{ color: 'text.secondary', gap: 2 }}
          className={classes.menuItem}
        >
          <ListItemText primary="Device Report" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>

        {feature?.device?.deviceSetting && (
          <MenuItem
            onClick={() => {
              setIsOpen(false);
              handleClicks('device_settings');
            }}
            sx={{ color: 'text.secondary', gap: 2 }}
            className={classes.menuItem}
          >
            <ListItemText primary="Device Settings" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}
        {userRole.toUpperCase() === 'SUPERADMIN' && (
          <MenuItem
            onClick={() => {
              setIsOpen(false);
              handleClicks('delete_device');
            }}
            sx={{ color: 'text.secondary', gap: 2 }}
            className={classes.menuItem}
          >
            <ListItemText primary="Delete Device" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}
        {userRole.toUpperCase() === 'SUPERADMIN' && (
          <MenuItem
            onClick={() => {
              setIsOpen(false);
              handleClicks('update_organization');
            }}
            sx={{ color: 'text.secondary', gap: 2 }}
            className={classes.menuItem}
          >
            <ListItemText
              primary="Organization Update"
              primaryTypographyProps={{ variant: 'body2' }}
            />
          </MenuItem>
        )}
      </Menu>
    </Box>
  );
}
